// /api/v2/web-leads/solar
import React, { ReactElement, useState } from "react";
import { Container, Row } from "react-bootstrap";
import NewLeadDetails from "../newLeadForm";
import Thankyou from "../thankyou";

export default function Banner(): ReactElement {
  // Step state to control navigation
  const [step, setStep] = useState<"LEAD_DETAILS" | "THANK_YOU">("LEAD_DETAILS");

  const handleNextStep = () => {
    if (step === "LEAD_DETAILS") {
      setStep("THANK_YOU");
    }
  };

  const handlePreviousStep = () => {
    if (step === "THANK_YOU") {
      setStep("LEAD_DETAILS");
    }
  };

  return (
    <div>
      <Row>
        {/* Render components based on the current step */}
        { step === "LEAD_DETAILS" ? (
          <NewLeadDetails
            onNext={(res) => {
              window.scrollTo(0, 0);
              handleNextStep(res);
            }}
            onBack={() => {
              window.scrollTo(0, 0);
              handlePreviousStep();
            }}
          />
        ) : (
          <Thankyou
            onNext={(res) => {
              window.scrollTo(0, 0);
              handleNextStep(res);
            }}
            onBack={() => {
              window.scrollTo(0, 0);
              handlePreviousStep();
            }}
          />
        )}
      </Row>
    </div>
  );
}
